/** URL segment of Integrations under the account (`/accounts/:accountId/integrations`). */
export const INTEGRATIONS_ROUTE_SEGMENT = 'integrations';

/** The Skill tools tab. Providers is the index, so a bare `/integrations` opens it. */
export const TOOLS_SEGMENT = 'tools';

export type IntegrationsTab = 'providers' | 'tools';
